import { Box, Typography } from '@mui/material';
import { formatCurrency } from '../../utils/Currency';
import { sharedColors, sharedStyles } from '../../utils/Style';

type PriceColumnProps = {
  value: number;
  specialValue?: number;
};

export const PriceColumn = (props: PriceColumnProps) => {
  const prices = [formatCurrency(props.value)];
  if (
    Number.isFinite(props.specialValue) &&
    props.value !== props.specialValue
  ) {
    prices.push(formatCurrency(props.specialValue!));
  }
  prices.reverse();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
      <Typography sx={sharedStyles.tableStringField}>{prices[0]}</Typography>
      {prices.length > 1 && (
        <Typography
          sx={{
            ...sharedStyles.tableStringField,
            textDecoration: 'line-through',
            color: sharedColors.statusRed,
          }}
        >
          {prices[1]}
        </Typography>
      )}
    </Box>
  );
};
